import axios from "axios";

const configuredApiBase = () => process.env.REACT_APP_API_BASE || "/v1/api";

export const legacyApiBase = () => {
  const configured = configuredApiBase().replace(/\/$/, "");
  if (/^https?:\/\//i.test(configured)) return configured;

  const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (isLocalDev) {
    const prefix = configured.startsWith("/") ? configured : `/${configured}`;
    return `${window.location.protocol}//${window.location.hostname}:3002${prefix}`;
  }

  return configured;
};

export const legacyApiUrl = (path) => {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${legacyApiBase()}${cleanPath}`;
};

export const getLegacyList = async (path, config) => {
  try {
    const response = await axios.get(legacyApiUrl(path), config);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.warn(`[legacyApi] ${path} unavailable`, error?.response?.status || error.message);
    return [];
  }
};

export const postLegacyJson = async (path, payload) => {
  const response = await fetch(legacyApiUrl(path), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed with status ${response.status}`);
  }
  return data;
};
